module.exports = __webpack_public_path__ + "static/img/numbers_icon_porting.cca8dde6.png";